import env from '../../environment';
import {postCreator, getCreator, putCreator, deleteCreator} from '../../http';

export const endpoints = {
  LIST_CRM_CAMPAIGNS: `${env.baseApiUrl}/winehouse/admin/crm/campaign`,
  CREATE_CRM_CAMPAIGN: `${env.baseApiUrl}/winehouse/admin/crm/campaign`,
  GET_CRM_CAMPAIGN_BY_ID: `${env.baseApiUrl}/winehouse/admin/crm/campaign/:campaignId`,
  EDIT_CRM_CAMPAIGN: `${env.baseApiUrl}/winehouse/admin/crm/campaign/:campaignId`,
  DELETE_CRM_CAMPAIGN: `${env.baseApiUrl}/winehouse/admin/crm/campaign/:campaignId`,

  GET_CAMPAIGN_EXECUTION: `${env.baseApiUrl}/winehouse/admin/crm/campaign/:campaignId/execution`,
  GET_CAMPAIGN_EXECUTION_BY_ID: `${env.baseApiUrl}/winehouse/admin/crm/campaign-execution/:executionId`,
};

export const listCrmCampaignsApi = getCreator(endpoints.LIST_CRM_CAMPAIGNS);
export const createCrmCampaignApi = postCreator(endpoints.CREATE_CRM_CAMPAIGN);
export const getCrmCampaignByIdApi = getCreator(
  endpoints.GET_CRM_CAMPAIGN_BY_ID
);
export const editCrmCampaignApi = putCreator(endpoints.EDIT_CRM_CAMPAIGN);
export const deleteCrmCampaignApi = deleteCreator(
  endpoints.DELETE_CRM_CAMPAIGN
);

export const getCampaignExecutionApi = getCreator(
  endpoints.GET_CAMPAIGN_EXECUTION
);

export const getCampaignExecutionByIdApi = getCreator(
  endpoints.GET_CAMPAIGN_EXECUTION_BY_ID
);
